import { render, staticRenderFns } from "./editSetting.vue?vue&type=template&id=059f4a0f&scoped=true&"
import script from "./editSetting.vue?vue&type=script&lang=js&"
export * from "./editSetting.vue?vue&type=script&lang=js&"
import style0 from "./editSetting.vue?vue&type=style&index=0&id=059f4a0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f4a0f",
  null
  
)

export default component.exports